import { connect } from 'react-redux'
import WorksTable from './works-table'
import {
  getWorksList,
  getPagination,
  getFetchRequest,
  anyWorkDeleting
} from '../../../../../stores/works/works.selectors'
import { fetchWorks } from '../../../../../stores/works/works.actions'
import { withRouter } from 'react-router-dom'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const works = getWorksList(state)
  return {
    works: works,
    noWorks: !works.length,
    pagination: getPagination(state),
    pending: getFetchRequest(state).pending || anyWorkDeleting(state)
  }
}

const mapDispatchToProps = (dispatch, { match }) => ({
  onPageChange: ({ selected }) =>
    dispatch(fetchWorks(match.params.id, { page: selected })).catch(
      errorHandler
    )
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(WorksTable)
)
